import { App } from 'vue';
import axios from 'axios';
import { registerVueWindowVar } from 'src/js/global';

export function useAxios(app: App) {
    // app.config.globalProperties.$axios = axios;
    registerVueWindowVar(app, '$axios', axios);
    axios.defaults.timeout = 10000;
    axios.interceptors.request.use(
        function (config: any) {
            config.metadata = {
                startTime: new Date(),
            };
            return config;
        },
        function (error) {
            return Promise.reject(error);
        },
    );
    //拦截响应response，进行错误处理
    axios.interceptors.response.use(
        function (response?: any) {
            // 成功处理
            response.config.metadata.endTime = new Date();
            response.duration =
                response.config.metadata.endTime - response.config.metadata.startTime;
            return response;
        },
        function (error) {
            // 失败处理
            error.config.metadata.endTime = new Date();
            error.duration = error.config.metadata.endTime - error.config.metadata.startTime;
            return Promise.reject(error);
        },
    );
}
